import React from 'react';
import { useNavigate } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMail, FiPhone, FiMapPin } = FiIcons;

const legalLinks = [
  { label: 'Privacy Policy', path: '/privacy-policy' },
  { label: 'Cookie Policy', path: '/cookie-policy' },
  { label: 'Terms of Service', path: '/terms-of-service' },
  { label: 'Acceptable Use Policy', path: '/acceptable-use-policy' },
];

export default function Footer() {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();

  return (
    <footer className="bg-black pt-24 pb-12 border-t border-[#222222]">
      <div className="container mx-auto px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-14 mb-20">
          <div className="col-span-1 lg:col-span-1">
            <div className="mb-8">
              <img
                src="https://berqwp-cdn.sfo3.cdn.digitaloceanspaces.com/cache/minotaur-solutions.com/wp-content/uploads/2024/12/logo-0-e1733737765551.webp?bwp"
                alt="Minotaur Solutions"
                className="h-14 w-auto object-contain"
              />
            </div>
            <p className="text-gray-500 text-sm leading-relaxed">
              The best time to secure your business was yesterday. The second-best time is today.
              Let Minotaur Solutions protect your data, reputation, and peace of mind.
            </p>
          </div>
          <div>
            <h4 className="text-white font-bold text-lg mb-8">Our Services</h4>
            <ul className="space-y-4">
              {['Cybersecurity', 'Governance', 'Risk', 'Compliance', 'vCISO', 'CSIRT', 'AI Governance'].map(item => (
                <li key={item}>
                  <a href="#services" className="text-gray-500 hover:text-brand-orange transition-colors text-sm">{item}</a>
                </li>
              ))}
            </ul>
          </div>
          <div className="col-span-1 lg:col-span-2">
            <h4 className="text-white font-bold text-lg mb-8">Get In Touch</h4>
            <ul className="space-y-6">
              <li className="flex items-start gap-4 text-gray-500 text-sm">
                <SafeIcon icon={FiMail} className="text-brand-orange mt-0.5 text-lg flex-shrink-0" />
                <a href="mailto:hello@minotaur-solutions.com" className="hover:text-brand-orange transition-colors">hello@minotaur-solutions.com</a>
              </li>
              <li className="flex items-start gap-4 text-gray-500 text-sm">
                <SafeIcon icon={FiPhone} className="text-brand-orange mt-0.5 text-lg flex-shrink-0" />
                <a href="tel:+3251470117" className="hover:text-brand-orange transition-colors">+32 51 470 117</a>
              </li>
              <li className="flex items-start gap-4 text-gray-500 text-sm">
                <SafeIcon icon={FiMapPin} className="text-brand-orange mt-0.5 text-lg flex-shrink-0" />
                <span>Beernemsteenweg 77, 8750 Wingene, Belgium</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="pt-8 border-t border-[#222222] flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-600 text-sm text-center md:text-left">
            Copyright © Minotaur Solutions BV 2005 - {currentYear}. All rights reserved.
          </p>
          <ul className="flex flex-wrap justify-center gap-6 text-sm">
            {legalLinks.map(item => (
              <li key={item.label}>
                <button
                  onClick={() => navigate(item.path)}
                  className="text-gray-600 hover:text-white transition-colors cursor-pointer bg-transparent border-none p-0"
                >
                  {item.label}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </footer>
  );
}